(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hover = window.matchMedia('(hover: hover)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- texte du titre : visible tout de suite (le script est en defer, le DOM est pret) ---------- */
  document.body.classList.add('is-ready');

  /* ---------- rideau d'intro : sur l'accueil seulement, decouple du texte pour ne pas retarder le LCP ---------- */
  var curtain = $('[data-curtain]');
  if (curtain) {
    if (reduce) { curtain.remove(); }
    else {
      setTimeout(function () {
        curtain.classList.add('is-out');
        setTimeout(function () { curtain.remove(); }, 1300);
      }, 700);
    }
  }

  /* ---------- navigation + progression ---------- */
  var nav = $('[data-nav]'), bar = $('[data-progress]');
  var lastY = window.scrollY, vel = 0;
  function onScroll() {
    var y = window.scrollY, max = document.documentElement.scrollHeight - window.innerHeight;
    nav.classList.toggle('is-stuck', y > 40);
    if (bar && max > 0) bar.style.transform = 'scaleX(' + (y / max).toFixed(4) + ')';
    vel += Math.abs(y - lastY); lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- menu mobile ---------- */
  var burger = $('.nav__burger');
  if (burger) {
    var setOpen = function (on) { nav.classList.toggle('is-open', on); burger.setAttribute('aria-expanded', on ? 'true' : 'false'); };
    burger.addEventListener('click', function () { setOpen(!nav.classList.contains('is-open')); });
    $$('.nav__links a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* ---------- titres découpés en mots ---------- */
  $$('[data-split]').forEach(function (h) {
    var words = h.textContent.trim().split(/ +/);
    h.setAttribute('aria-label', h.textContent.trim());
    h.textContent = '';
    words.forEach(function (w, i) {
      var box = document.createElement('span'); box.className = 'w'; box.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('span'); inner.textContent = w; inner.style.setProperty('--i', i);
      box.appendChild(inner); h.appendChild(box);
      if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
    });
  });

  /* ---------- révélation au scroll ---------- */
  var revealEls = $$('[data-reveal]');
  revealEls.forEach(function (el) {
    var sibs = $$(':scope > [data-reveal]', el.parentElement);
    el.style.setProperty('--d', (sibs.indexOf(el) * 0.09) + 's');
  });
  var watch = revealEls.concat($$('[data-split]'), $$('.frame'));
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    watch.forEach(function (el) { io.observe(el); });
  } else { watch.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- mot qui tourne dans le titre ---------- */
  var swap = $('[data-swap]');
  if (swap && !reduce) {
    var words = $$('.swap__word', swap), cur = 0;
    setInterval(function () {
      var next = (cur + 1) % words.length, old = words[cur];
      old.classList.remove('is-on'); old.classList.add('is-out');
      words[next].classList.remove('is-out'); void words[next].offsetWidth; words[next].classList.add('is-on');
      setTimeout(function () {
        old.classList.remove('is-out'); old.style.transition = 'none'; old.style.transform = 'translateY(170%)';
        void old.offsetWidth; old.style.transition = ''; old.style.transform = '';
      }, 720);
      cur = next;
    }, 2400);
  }

  /* ---------- souris : parallaxe, curseur, aimants ---------- */
  var mx = 0, my = 0, cx = -100, cy = -100, tx = -100, ty = -100;
  var depthEls = $$('[data-depth]');
  var cursor = $('[data-cursor]');
  if (!reduce) {
    window.addEventListener('mousemove', function (e) {
      mx = (e.clientX / window.innerWidth - 0.5) * 2; my = (e.clientY / window.innerHeight - 0.5) * 2;
      tx = e.clientX; ty = e.clientY;
      if (cursor) cursor.classList.add('is-on');
    }, { passive: true });
    document.addEventListener('mouseleave', function () { if (cursor) cursor.classList.remove('is-on'); });
    if (cursor && hover) {
      $$('a, button, .video, .tile').forEach(function (el) {
        el.addEventListener('mouseenter', function () { cursor.classList.add('is-big'); });
        el.addEventListener('mouseleave', function () { cursor.classList.remove('is-big'); });
      });
    }
    if (hover) {
      $$('[data-magnet]').forEach(function (el) {
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect();
          var x = (e.clientX - (r.left + r.width / 2)) * 0.28, y = (e.clientY - (r.top + r.height / 2)) * 0.4;
          el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; });
      });
    }
  }

  /* ---------- boucle d'animation (parallaxe, curseur, bandeaux, sticker) ---------- */
  var tracks = $$('.marquee__track');
  var offsets = tracks.map(function () { return 0; });
  var sticker = $('.sticker__spin'), stickerAnim = null;
  var zoomImgs = $$('.frame img');
  var parallaxEls = $$('[data-parallax]');
  var smoothVel = 0;
  function frame() {
    var sy = window.scrollY;
    smoothVel += (Math.min(vel, 90) - smoothVel) * 0.12; vel *= 0.6;

    cx += (tx - cx) * 0.2; cy += (ty - cy) * 0.2;
    if (cursor) cursor.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px)';

    depthEls.forEach(function (el) {
      var d = parseFloat(el.getAttribute('data-depth'));
      var base = getComputedStyle(el).getPropertyValue('--r').trim() || '0deg';
      el.style.transform = 'translate(' + (mx * d * 0.6).toFixed(1) + 'px,' + (my * d * 0.6 - sy * d * 0.012).toFixed(1) + 'px) rotate(' + base + ')';
    });

    tracks.forEach(function (t, i) {
      var dir = parseFloat(t.getAttribute('data-dir')) || 1;
      offsets[i] -= dir * (0.9 + smoothVel * 0.25);
      var half = t.scrollWidth / 2;
      if (offsets[i] <= -half) offsets[i] += half;
      if (offsets[i] > 0) offsets[i] -= half;
      t.style.animation = 'none';
      t.style.transform = 'translateX(' + offsets[i].toFixed(1) + 'px)';
    });

    if (sticker) {
      if (!stickerAnim && sticker.getAnimations) stickerAnim = sticker.getAnimations()[0];
      if (stickerAnim) stickerAnim.playbackRate = 1 + smoothVel * 0.35;
    }

    zoomImgs.forEach(function (img) {
      var r = img.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var p = (r.top + r.height / 2) / window.innerHeight - 0.5;
      img.style.transform = 'scale(1.12) translateY(' + (p * -5).toFixed(2) + '%)';
    });
    parallaxEls.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > window.innerHeight) return;
      var p = (box.top + box.height / 2 - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = 'translate3d(0,' + (p * -10).toFixed(2) + '%,0)';
    });
    requestAnimationFrame(frame);
  }
  if (!reduce) requestAnimationFrame(frame);

  /* ---------- tuiles : inclinaison ---------- */
  if (!reduce && hover) {
    $$('[data-tilt]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (-y * 8).toFixed(2) + 'deg) rotateY(' + (x * 10).toFixed(2) + 'deg) translateY(-6px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- barre de navigation basse (mobile) : bouton "Haut" ---------- */
  var topBtn = $('[data-scrolltop]');
  if (topBtn) {
    var topShown = false, topTicking = false;
    function updateTopBtn() {
      topTicking = false;
      var show = window.scrollY > window.innerHeight * 0.6;
      if (show === topShown) return;
      topShown = show;
      if (show) {
        topBtn.hidden = false;
        requestAnimationFrame(function () { topBtn.classList.add('is-visible'); });
      } else {
        topBtn.classList.remove('is-visible');
        setTimeout(function () { if (!topShown) topBtn.hidden = true; }, reduce ? 0 : 250);
      }
    }
    window.addEventListener('scroll', function () {
      if (!topTicking) { topTicking = true; requestAnimationFrame(updateTopBtn); }
    }, { passive: true });
    updateTopBtn();
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      topBtn.blur();
    });
  }

  /* ---------- pause des animations en continu hors champ ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    var sectionIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
    }, { rootMargin: '200px 0px' });
    $$('.shopify-section').forEach(function (el) { sectionIo.observe(el); });
  }

  /* ---------- filtre salé / sucré ---------- */
  var onCardsPage = !!$('#dlg'); /* la page Recettes gère son propre filtre (recettes.js) */
  var chips = onCardsPage ? [] : $$('.chip'), cards = $$('.card');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var f = chip.getAttribute('data-filter');
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      cards.forEach(function (card) {
        var show = f === 'all' || card.getAttribute('data-cat') === f;
        card.hidden = !show; card.classList.remove('is-in');
        if (show) { void card.offsetWidth; card.classList.add('is-in'); }
        var fl = $('.card__flip', card); if (fl) fl.setAttribute('aria-pressed', 'false');
      });
    });
  });

  /* ---------- cartes : 3D à la souris + confettis au retournement ---------- */
  function confetti(x, y) {
    if (reduce) return;
    for (var i = 0; i < 22; i++) {
      var c = document.createElement('span'); c.className = 'confetti';
      c.style.left = x + 'px'; c.style.top = y + 'px';
      document.body.appendChild(c);
      var a = Math.random() * Math.PI * 2, d = 90 + Math.random() * 160;
      var anim = c.animate([
        { transform: 'translate(0,0) rotate(0) scale(1)', opacity: 1 },
        { transform: 'translate(' + Math.cos(a) * d + 'px,' + (Math.sin(a) * d - 40) + 'px) rotate(' + (Math.random() * 720 - 360) + 'deg) scale(.6)', opacity: 0 }
      ], { duration: 800 + Math.random() * 500, easing: 'cubic-bezier(.15,.7,.3,1)' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(c);
    }
  }
  cards.forEach(function (card) {
    var flip = $('.card__flip', card);
    if (!flip) return;
    flip.addEventListener('click', function (e) {
      var on = flip.getAttribute('aria-pressed') === 'true';
      flip.setAttribute('aria-pressed', on ? 'false' : 'true');
      var r = flip.getBoundingClientRect();
      confetti(e.clientX || r.left + r.width / 2, e.clientY || r.top + r.height / 2);
    });
    if (!reduce && hover) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        card.classList.add('is-tilting');
        card.style.transform = 'perspective(1000px) rotateX(' + (-y * 9).toFixed(2) + 'deg) rotateY(' + (x * 12).toFixed(2) + 'deg)';
      });
      card.addEventListener('mouseleave', function () { card.classList.remove('is-tilting'); card.style.transform = ''; });
    }
  });
})();
